module.exports = __webpack_public_path__ + "static/media/holiday-default.0e15a8cf.svg";